import HondaPartnerSvg from 'src/assets/images/honda-partner.svg';
import styled from 'styled-components';

export const HondaPartner = styled(HondaPartnerSvg)`
  height: 1.5625rem;
`;
